
import React from 'react';
import { Calendar, Clock } from 'lucide-react';
import { Button } from '../ui/button';
import { formatHours } from '@/utils/timeUtils';

interface WeeklyActionsProps {
  weekData: Array<{
    date: string;
    dayName: string;
    entries: unknown[];
    totalMinutes: number;
  }>;
  onWeekChange?: (direction: 'prev' | 'next') => void;
}

export const WeeklyActions: React.FC<WeeklyActionsProps> = ({
  weekData,
  onWeekChange
}) => {
  // Calculer le total de la semaine
  const weekTotal = weekData.reduce((sum, day) => sum + day.totalMinutes, 0);
  const weekTotalHours = weekTotal / 60;

  // Vérifier si la semaine a des données
  const hasData = weekData.some(day => day.entries.length > 0);

  return (
    <div className="space-y-4">
      {/* Résumé de la semaine */}
      <div className="bg-white p-4 rounded-lg border shadow-sm">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Clock className="h-5 w-5 text-blue-600" />
            <span className="font-medium">Total de la semaine</span>
          </div>
          <div className="text-right">
            <div className="text-2xl font-bold text-blue-600">
              {formatHours(weekTotal)}
            </div>
            <div className="text-sm text-gray-500">
              {weekData.filter(day => day.entries.length > 0).length} jours avec des entrées
            </div>
          </div>
        </div>
      </div>

      {/* Actions */}
      <div className="flex gap-3 justify-center">
        <Button 
          variant="outline" 
          onClick={() => onWeekChange?.('prev')}
        >
          <Calendar className="h-4 w-4 mr-2" />
          Semaine précédente
        </Button>

        <Button 
          variant="outline" 
          onClick={() => onWeekChange?.('next')}
        >
          <Calendar className="h-4 w-4 mr-2" />
          Semaine suivante
        </Button>
      </div>

      {/* Messages d'aide */}
      {!hasData && (
        <div className="text-center text-gray-500 text-sm">
          Aucune entrée de temps pour cette semaine
        </div>
      )}
      <div className="text-center text-xs text-muted-foreground">
        Soumission/approbation de feuille de temps: à activer quand le backend `timesheets` sera disponible.
      </div>
    </div>
  );
};
